// src/components/AboutUs.js
import React from 'react';
import './AboutUs.css'; // Create this CSS file for about us specific styles

function AboutUs() {
  return (
    <div className="about-us-container">
      <h1>About Us</h1>
      <p>At IronBhai, we make laundry, ironing, dry cleaning, and saree rolling services easy, reliable, and affordable for busy people. Our mission is simple — to save your time and keep your clothes looking their best.</p>
      <p>We combine professional garment care with modern convenience. With just a few taps on the IronBhai app, you can schedule pickups and deliveries right at your doorstep. Our trained team ensures that every item is handled with care, using the right techniques for each fabric.</p>
      <h2>Why Choose IronBhai?</h2>
      <ul>
        <li><strong>Doorstep Service:</strong> Hassle-free pickup & delivery.</li>
        <li><strong>Premium Quality:</strong> Expert ironing, cleaning, and finishing.</li>
        <li><strong>Affordable Pricing:</strong> Transparent rates with no hidden charges.</li>
        <li><strong>Time-Saving:</strong> Focus on what matters while we handle your laundry.</li>
        <li><strong>Eco-Friendly:</strong> Sustainable cleaning practices where possible.</li>
      </ul>
      <p>We are proud to serve our customers with a blend of traditional care and modern efficiency — making IronBhai your trusted clothing care partner.</p>
      <h2>Contact Information</h2>
      <ul>
        <li>📍 <strong>Head Office:</strong> Hyderabad, Telangana</li>
        <li>🌐 <strong>Website:</strong> <a href="https://www.ironbhai.com" target="_blank" rel="noopener noreferrer">www.ironbhai.com</a></li>
        <li>📧 <strong>Email:</strong> <a href="mailto:support@ironbhai.com">support@ironbhai.com</a></li>
      </ul>
    </div>
  );
}

export default AboutUs;
